const __WEBPACK_NAMESPACE_OBJECT__ = require("emoji-mart-vue-fast/data/all.json");